// Author Liang Gang Qiang
// Date 2021-11-27 10:12:22

import * as model from "@/model/mintalMes/quality/MintalMesQualityProductionSampleModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";
import {customVuexEntityPatternFactory} from "@/store/em/commonPattern/customVuexEntityPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesQualityProductionSample(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_QUALITY_URL,
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'inspectFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'createFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'inspectEntity',
        entityConstructor: model.MintalMesQualityProductionSample
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'createEntity',
        entityConstructor: model.MintalMesQualityProductionSample
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'inspectVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'createVo'
    })
    .buildStore()
